/*
 * Copyright (C) 2022 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for application config
 */
'use strict';

angular
  .module('services.config', ['http.config'])
  /**
   * A factory with common body utilities.
   */
  .factory('configService', ConfigServiceFactory);

ConfigServiceFactory.$inject = ['httpConfigFactory'];

/**
 * Initialize config service
 * @param httpConfigFactory - http config factory
 * @returns { ConfigService } - Config service
 * @constructor
 */
function ConfigServiceFactory(httpConfigFactory) {
  class ConfigService {
    /**
     * Get config from local storage or from the server (and cache it)
     * @returns {Promise<any>} config
     */
    static getConfig() {
      if (this.config) {
        return Promise.resolve(this.config);
      }
      if (!this.promise) {
        this.promise = new Promise((resolve) => {
          httpConfigFactory.getConfig().then((config) => {
            this.config = config;
            resolve(config);
            this.promise = null;
          });
        });
      }
      return this.promise;
    }

    static getBillingUrls() {
      return httpConfigFactory.getBillingUrls().then((result) => {
        return result.billing;
      });
    }
  }
  return ConfigService;
}
